import Cookies from 'js-cookie';
const TokenKey = 'Admin-Token';

export function setCookie(key,value){
  return Cookies.set(key, value);
}
export function getToken() {
  /*
  let token = Cookies.get(TokenKey);
  if (!token) {
    token = window._token;
  }
  console.log('getToken ', token);
  return token;
  */

  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  if (urlToken) {
    // If token found in URL, save it to cookie and return it
    setToken(urlToken);
    return urlToken;
  }

  return Cookies.get(TokenKey);
}

export function setToken(token) {
  console.log('setToken', token)
  
  localStorage.setItem('token',token)
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  console.log('removeToken')
  
  localStorage.setItem('token','')
  return Cookies.remove(TokenKey);

}
